import Vue from 'vue'

import {
  FmvLineChart,
  FmvAreaChart,
  FmvBarChart,
  FmvDoughnutChart,
  FmvRadarChart
} from 'fmv-charts'

Vue.component('FmvLineChart', FmvLineChart)
Vue.component('FmvAreaChart', FmvAreaChart)
Vue.component('FmvBarChart', FmvBarChart)
Vue.component('FmvDoughnutChart', FmvDoughnutChart)
Vue.component('FmvRadarChart', FmvRadarChart)